import React from 'react'
import { InvestmentHeader } from 'src/components/Investment/Investment Header/InvestmentHeader'
import { InvestmentToggle } from 'src/components/Investment/InvestmentToggle'
import SEO from 'src/seo'

const Investment = () => {
  return (
    <div>
      <SEO title="Investment" />
      <InvestmentHeader />
      <InvestmentToggle />
    </div>
  )
}
export { Investment }
